export class MonthlyScheduleEvent {
  // variables

  dateEvent: Date;
  id: number;
}
